import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/lib/i18n";

export default function Preloader({ onComplete }) {
  const [count, setCount] = useState(0);
  const { t } = useLanguage();

  useEffect(() => {
    let v = 0;
    const id = setInterval(() => {
      v += Math.floor(Math.random() * 4) + 2;
      if (v >= 100) {
        v = 100;
        clearInterval(id);
        setTimeout(onComplete, 500);
      }
      setCount(v);
    }, 26);
    return () => clearInterval(id);
  }, [onComplete]);

  return (
    <motion.div
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[200] bg-[#050505] flex flex-col items-center justify-center"
      data-testid="preloader"
    >
      <motion.img
        src="/fenrion-logo.png"
        alt="Fenrion AI"
        initial={{ opacity: 0, scale: 0.82, filter: "blur(12px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="w-72 md:w-[26rem] mix-blend-screen drop-shadow-[0_0_60px_rgba(255,90,0,0.35)]"
        data-testid="preloader-logo"
      />
      <div className="mt-12 w-52 h-px bg-white/10 relative overflow-hidden">
        <div
          className="absolute left-0 top-0 h-full bg-[#FF5A00] transition-[width] duration-100"
          style={{ width: `${count}%` }}
        />
      </div>
      <div className="mt-4 flex items-baseline gap-2">
        <span className="font-syne font-bold text-sm text-[#FFB800] tabular-nums" data-testid="preloader-counter">
          {String(count).padStart(3, "0")}%
        </span>
        <span className="text-[10px] tracking-[0.3em] uppercase text-neutral-600">{t("preloader.igniting")}</span>
      </div>
    </motion.div>
  );
}
